/* eslint-disable react/react-in-jsx-scope */

import { useEffect, useState } from "react"
import toastr from "toastr"
import uploadFileToBlob, { getBlobsInContainer } from "./azureBlob"

const prefixoProcesso = processo =>
  processo ? processo.replace(/\//g, "-") : ""

const FileUpload = props => {
  const [storageConfigured, setStorageConfigured] = useState(false)

  const [nomeArquivo, setNomeArquivo] = useState(null)
  const [filtroLista, setFiltroLista] = useState(null)

  const [blobList, setBlobList] = useState(null)
  const [blobListAll, setBlobListAll] = useState(null)

  const [filesSelected, setFilesSelected] = useState([])

  const [uploading, setUploading] = useState(false)
  const [inputKey, setInputKey] = useState(Math.random().toString(36))

  const STORAGE_SASTOKEN_AUTOS = window.sessionStorage.getItem(
    "STORAGE_SASTOKEN_AUTOS"
  )
  const STORAGE_SASTOKEN_PUBLI = window.sessionStorage.getItem(
    "STORAGE_SASTOKEN_PUBLI"
  )
  const STORAGE_ACCOUNTNAME = window.sessionStorage.getItem(
    "STORAGE_ACCOUNTNAME"
  )

  const [sasTokenAutos, setSasTokenAutos] = useState(STORAGE_SASTOKEN_AUTOS)
  const [sasTokenPublicacao, setSasTokenPublicacao] = useState(
    STORAGE_SASTOKEN_PUBLI
  )
  const [storageAccountName, setStorageAccountName] =
    useState(STORAGE_ACCOUNTNAME)

  useEffect(() => {
    const interval = setInterval(() => {
      const newSasTokenAutos = window.sessionStorage.getItem(
        "STORAGE_SASTOKEN_AUTOS"
      )
      const newSasTokenPublicacao = window.sessionStorage.getItem(
        "STORAGE_SASTOKEN_PUBLI"
      )
      const newStorageAccountName = window.sessionStorage.getItem(
        "STORAGE_ACCOUNTNAME"
      )

      if (newSasTokenAutos !== sasTokenAutos) {
        setSasTokenAutos(newSasTokenAutos)
      }

      if (newSasTokenPublicacao !== sasTokenPublicacao) {
        setSasTokenPublicacao(newSasTokenPublicacao)
      }

      if (newStorageAccountName !== storageAccountName) {
        setStorageAccountName(newStorageAccountName)
      }

      setStorageConfigured(
        !(!storageAccountName || !sasTokenAutos || !sasTokenPublicacao)
      )
    }, 1000)

    return () => clearInterval(interval)
  }, [sasTokenAutos, sasTokenPublicacao, storageAccountName])

  useEffect(() => {
    if (props.container == "autos") {
      setFiltroLista(prefixoProcesso(props.processo))
    } else if (props.container == "publicacoes") {
      setFiltroLista("BasePjeLeads")

      if (props.tipoPublicacao == "EdicaoLote") {
        setNomeArquivo("EdicaoLote.xlsx")
        setFiltroLista("EdicaoLote")
      } else if (props.tipoPublicacao == "Garimpo")
        setNomeArquivo("BasePjeLeads_Garimpo.xlsx")
      else setNomeArquivo("BasePjeLeads-PJE.xlsx")
    } else {
      console.log(
        'A propriedade "container" do componente FileUpload é inválida! ',
        props.container
      )
      return
    }
  }, [props])

  const MAX_FILES = 5
  const MAX_SIZE_MB = 50

  const onFileChange = event => {
    const selectedFiles = Array.from(event.target.files)

    if (selectedFiles.length > MAX_FILES) {
      alert(`Você pode selecionar no máximo ${MAX_FILES} arquivos.`)
      return
    }

    const invalidFiles = selectedFiles.filter(
      file => file.size > MAX_SIZE_MB * 1024 * 1024
    )
    if (invalidFiles.length > 0) {
      alert(
        `O arquivo selecionado excede o limite máximo permitido de ${MAX_SIZE_MB} MB.`
      )
      return
    }

    setFilesSelected(selectedFiles)
  }

  const removeFileFromSelection = index => {
    setFilesSelected(prevFiles => {
      const updatedFiles = [...prevFiles]
      updatedFiles.splice(index, 1)
      return updatedFiles
    })

    setInputKey(Math.random().toString(36))
  }

  const deleteFileFromBlob = async fileUrl => {
    try {
      const blobName = fileUrl.split("/").pop()

      const sasToken =
        props.container === "autos"
          ? `?${sasTokenAutos}`
          : `?${sasTokenPublicacao}`

      const deleteUrl = `https://${storageAccountName}.blob.core.windows.net/${props.container}/${blobName}${sasToken}`

      const response = await fetch(deleteUrl, {
        method: "DELETE",
      })

      if (response.ok) {
        toastr.success("Arquivo excluído com sucesso!", "Sucesso")

        await loadListFiles()
      } else {
        const errorText = await response.text()
        toastr.error(`Erro ao excluir o arquivo: ${errorText}`, "Erro")
        console.error("Erro na resposta:", response.status, errorText)
      }
    } catch (error) {
      console.error("Erro ao excluir o arquivo:", error)
      toastr.error("Erro ao tentar excluir o arquivo.", "Erro")
    }
  }

  const onFileUpload = async () => {
    if (filesSelected.length > 0) {
      setUploading(true)

      try {
        const prefixo = prefixoProcesso(props.processo)

        if (props.container == "autos" && !prefixo) {
          throw new Error("Processo nao informado")
        }

        for (const file of filesSelected) {
          const nomeFinal =
            props.container == "autos" ? `${prefixo}-${file.name}` : nomeArquivo
          const fileWithCustomName = new File([file], nomeFinal, {
            type: file.type,
          })

          await uploadFileToBlob(fileWithCustomName, props.container)
        }

        toastr.success("Arquivo(s) anexado(s) com sucesso!", "Sucesso")
      } catch (error) {
        console.error("Erro ao anexar o arquivo:", error)
        toastr.error(
          "Não foi possível anexar o arquivo. Tente novamente.",
          "Erro"
        )
      } finally {
        await loadListFiles()
        setUploading(false)
        setFilesSelected([])
        setInputKey(Math.random().toString(36))
      }
    }
  }

  const loadListFiles = async () => {
    try {
      const blobsInContainer = await getBlobsInContainer(props.container)
      setBlobList(blobsInContainer)

      const blobsInContainerAll = await getBlobsInContainer(
        props.container,
        null,
        true
      )
      setBlobListAll(blobsInContainerAll)

      const prefixo = prefixoProcesso(props.processo)

      if (
        props.container == "autos" &&
        prefixo &&
        blobsInContainer.filter(name => name.includes(prefixo)).length > 0
      ) {
        props.anexado(true)
      }
    } catch (error) {
      console.error("Erro ao carregar os documentos anexados:", error)
      toastr.error("Não foi possível carregar os documentos anexados.", "Erro")
      setBlobList([])
    }
  }

  const DisplayForm = () => (
    <div>
      <input
        type="file"
        onChange={onFileChange}
        key={inputKey || ""}
        multiple
      />
      <button
        className="btn btn-info btn-sm mx-1"
        type="submit"
        onClick={onFileUpload}
      >
        Anexar
      </button>
      <div>
        <small className="text-muted">
          Tamanho máximo permitido por arquivo: {MAX_SIZE_MB} MB
        </small>
      </div>
    </div>
  )

  const DisplayAutoFromContainer = () => (
    <div>
      <label className="form-label">Arquivos Selecionados</label>
      <ul>
        {filesSelected.map((file, index) => (
          <li key={index}>
            {file.name}
            <button
              style={{ padding: "0.1rem 0.3rem", fontSize: "0.6rem" }}
              className="btn btn-danger mx-2 rounded-circle"
              onClick={() => removeFileFromSelection(index)}
            >
              ✖
            </button>
          </li>
        ))}
      </ul>

      <label className="form-label">Itens Anexados</label>
      <ul>
        {blobList
          .filter(name => filtroLista && name.includes(filtroLista))
          .map(item => (
            <li key={item}>
              <div>
                <a href={item} target="_blank" rel="noreferrer">
                  {item.substring(item.lastIndexOf("/") + 1)}
                </a>
                <button
                  style={{ padding: "0.1rem 0.3rem", fontSize: "0.6rem" }}
                  className="btn btn-danger mx-2 rounded-circle"
                  onClick={() => deleteFileFromBlob(item)}
                >
                  ✖
                </button>
              </div>
            </li>
          ))}
      </ul>
    </div>
  )

  const DisplayProcessedFromContainer = () => (
    <div>
      <label className="form-label">Últimos Processados</label>
      <ul>
        {blobListAll
          .filter(name => name.includes("processados/" + filtroLista))
          .sort()
          .reverse()
          .slice(0, 10)
          .map(item => {
            return (
              <li key={item}>
                <div>
                  <a href={item} target="_blank" rel="noreferrer">
                    {item.substring(item.lastIndexOf("/") + 1)}
                  </a>
                </div>
              </li>
            )
          })}
      </ul>
    </div>
  )

  useEffect(() => {
    if (blobList == null) {
      loadListFiles()
    }
  }, [blobList])

  useEffect(() => {
    const handleFileUploaded = (event) => {
      const { containerName } = event.detail
      if (containerName === props.container) {
        console.log('Arquivo enviado via chat detectado, recarregando lista...')
        loadListFiles()
      }
    }

    window.addEventListener('fileUploadedToAzure', handleFileUploaded)
    
    return () => {
      window.removeEventListener('fileUploadedToAzure', handleFileUploaded)
    }
  }, [props.container])

  return (
    <div>
      {storageConfigured && !uploading && DisplayForm()}
      {storageConfigured && uploading && (
        <div>
          <i className="bx bx-loader bx-spin h1 align-middle me-2" />
          Uploading...
        </div>
      )}
      <hr />
      {storageConfigured &&
        blobList &&
        blobList.length > 0 &&
        DisplayAutoFromContainer()}
      {storageConfigured &&
        blobListAll &&
        blobListAll.length > 0 &&
        props.container == "publicacoes" &&
        DisplayProcessedFromContainer()}
      {!storageConfigured && <div>Storage is not configured.</div>}
      {!props.container && (
        <div color="red">
          <i className="mdi font-size-20 mdi-alert-outline me-2" />A propriedade
          "container" do componente FileUpload não foi definida.
        </div>
      )}
    </div>
  )
}

export default FileUpload
